import { Range, Record, List, Map } from "immutable";

import * as actions from "./actions";

const InitialState = Record({
  online: true,
  isOnlineInterval: null,
  refreshTokenInterval: null,
  sidebar: new (Record({
    open: false,
    docked: true,
    mql: null
  }))(),
  patchCounter: 0,
  patchSuccess: false,
  getCounter: 0,
  postCounter: 0,
  postSuccess: false,
  shouldMenuLeftRerender: false,
  draggingItemUID: "",
  hoveringItemUID: "",
  isDayPickerVisible: ""
});
const initialState = new InitialState();

export default function settingsReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return initialState.mergeDeep(state);

  if (action.type.substring(0, 5) === "PATCH") {
    if (
      action.type.substring(action.type.length - 7, action.type.length) ===
        "SUCCESS"
    ) {
      state = state.setIn(["patchCounter"], state.patchCounter - 1);
      state = state.setIn(["patchSuccess"], true);
    } else if (
      action.type.substring(action.type.length - 5, action.type.length) ===
        "ERROR"
    ) {
      state = state.setIn(["patchCounter"], state.patchCounter - 1);
      state = state.setIn(["patchSuccess"], false);
    } else {
      state = state.setIn(["patchCounter"], state.patchCounter + 1);
      state = state.setIn(["patchSuccess"], false);
    }
  }

  if (action.type.substring(0, 3) === "GET") {
    if (
      action.type.substring(action.type.length - 7, action.type.length) ===
        "SUCCESS"
    ) {
      state = state.setIn(["getCounter"], state.getCounter - 1);
    } else if (
      action.type.substring(action.type.length - 5, action.type.length) ===
        "ERROR"
    ) {
      state = state.setIn(["getCounter"], state.getCounter - 1);
    } else {
      state = state.setIn(["getCounter"], state.getCounter + 1);
    }
  }

  if (action.type.substring(0, 4) === "POST") {
    if (
      action.type.substring(action.type.length - 7, action.type.length) ===
        "SUCCESS"
    ) {
      state = state.setIn(["postCounter"], state.postCounter - 1);
      state = state.setIn(["postSuccess"], true);
    } else if (
      action.type.substring(action.type.length - 5, action.type.length) ===
        "ERROR"
    ) {
      state = state.setIn(["postCounter"], state.postCounter - 1);
      state = state.setIn(["postSuccess"], false);
    } else {
      state = state.setIn(["postCounter"], state.postCounter + 1);
      state = state.setIn(["postSuccess"], false);
    }
  }

  switch (action.type) {
    case actions.SET_ONLINE:
      return state.setIn(["online"], action.payload);

    case actions.SET_IS_ONLINE_INTERVAL:
      return state.setIn(["isOnlineInterval"], action.payload);

    case actions.SET_REFRESH_TOKEN_INTERVAL:
      return state.setIn(["refreshTokenInterval"], action.payload);

    case actions.SET_SIDEBAR:
      return state.setIn(["sidebar", action.payload.key], action.payload.value);

    case actions.UPDATE_MEDIA_QUERY:
      return state.setIn(["sidebar", "docked"], state.sidebar.mql.matches);

    case actions.SET_PATCH_SUCCESS_FALSE:
      return state.setIn(["patchSuccess"], false);

    case actions.SET_POST_SUCCESS_FALSE:
      return state.setIn(["postSuccess"], false);

    case actions.SET_SHOULD_MENU_LEFT_RERENDER:
      return state.setIn(
        ["shouldMenuLeftRerender"],
        action.data.shouldRerender
      );

    case actions.SET_DRAGGING_ITEM_UID:
      return state.setIn(["draggingItemUID"], action.payload.uid);

    case actions.SET_HOVERING_ITEM_UID:
      return state.setIn(["hoveringItemUID"], action.payload.uid);

    case actions.SET_IS_DAY_PICKER_VISIBLE:
      return state.setIn(["isDayPickerVisible"], action.payload.isVisible);
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/common/settings/reducer.js